import EventViewHeader from "./EventViewHeader";
import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import BulkUpload from "./bulkuploadModal";
import { ApiUrl } from "../ApiUrl";
import { toast } from "react-toastify";
import Loader from "../loader";
import ClientsFilterbar from "./clientsFilterbar";
import { internalUsers } from "../constants/userTypes";
import { format } from "date-fns";
import * as XLSX from "xlsx";
import DraggableHeaderCell from "./EventsPage/DraggableHeaderCell";
import { horizontalListSortingStrategy } from "@dnd-kit/sortable";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
  KeyboardSensor,
} from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { debounce } from "lodash";
import AddViewModal from "./EventsPage/AddViewModal";
import useGetViewsData from "../hooks/useGetViewsData";
import { useGetEventColumns } from "../hooks/useGetEventColumns";
import { AllClientColoumnData } from "../utils/data";

const Clients = ({
  isDarkMode,
  setDisplayComponent,
  setPrevDisplay,
  seListId,
  setIsLoading,
}) => {
  var button = document.getElementById("openViewModal");
  const { language } = useLanguage();
  const {
    noShowOptions,
    visitStatusOptions,
    confirmationStatusOptions,
    prospectiveSourceOptions,
    prospectiveSourceOptions2,
    appointmentOption,
    textOptions2,
    textOptions,
    allfields,
    defaultViewColumns,
  } = useGetEventColumns(language);
  const userType = localStorage.getItem("userType");
  console.log("userTypeuserType",userType)
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const clientsFilterData = JSON.parse(
    localStorage.getItem("clientsFilterData")
  );
  const clientsFilterPostData = JSON.parse(
    localStorage.getItem("clientsFilterPostData")
  );
  const [deleteStates, setDeleteStates] = useState();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingZip, setDownloadingZip] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [listIds, setListIds] = useState([]);
  const [configIds, setConfigIds] = useState([]);
  const [checkedFields, setCheckedFields] = useState(clientsFilterData || []);
  const token = localStorage.getItem("token");
  const [filtersData, setFiltersData] = useState(clientsFilterPostData || []);
  const [dealershipDetail, setDealershipDetail] = useState("");
  const [callStatusOptions, setCallStatusOptions] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [prospectiveType, setProspectiveType] = useState([]);
  const [clickedRow, setClickedRow] = useState(null);
  const [links, setLinks] = useState({
    csv_template_fr: "",
    csv_template_en: ""
  });
  const data = useGetViewsData("client");
  const [tableViews, setTableViews] = useState([]);
  const [currentView, setCurrentView] = useState(defaultViewColumns);
  const [viewData, setViewData] = useState(null);
  const columnWidthsRef = useRef({});
  const pendingStateUpdate = useRef(false);
  useEffect(() => {
    // Get the current URL
    var currentUrl = window.location.href;
    // Check if '=' is found and extract the text after it
    const equalsIndex = currentUrl.indexOf("=");
    if (equalsIndex !== -1) {
      const secondEqualsIndex = currentUrl.indexOf("=", equalsIndex + 1);

      if (secondEqualsIndex !== -1) {
        const lastParameterValue = currentUrl.substring(secondEqualsIndex + 1);
        setEventId(lastParameterValue);
      }
    }
  });

  useEffect(() => {
    const getFiltersData = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-fillter", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          const filteredFields = allfields?.filter(
            (field) => data?.fillter[field.name] === 1
          );

          setCheckedFields(filteredFields);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching brands", error);
        // Handle error or show a toast if needed
      }
    };
    if (token && eventId) {
      fetchData();
      getExternalUsers();
      // getListIds();
    }
    if (data?.user_views) {

      const processColumns = (columns) => {
      // let modifiedCol = JSON.parse(columns)

      // console.log("columns",columns,modifiedCol)
      return columns.map((col) => {
        const newCol = { ...col };

        // Evaluate `width`
        if (typeof newCol.width === "string") {
          try {
            newCol.width = Function(
              "language",
              `return (${newCol.width});`
            )(language);
          } catch (e) {
            console.error("Error evaluating width:", col.width, e);
          }
        }

        // Evaluate `minWidth`
        if (typeof newCol.minWidth === "string") {
          try {
            newCol.minWidth = Function(
              "language",
              `return (${newCol.minWidth});`
            )(language);
          } catch (e) {
            console.error("Error evaluating minWidth:", col.minWidth, e);
          }
        }

        // Evaluate content (only if accessing translations)
        if (
          typeof newCol.content === "string" &&
          newCol.content.includes("translations")
        ) {
          try {
            newCol.content = Function(
              "language",
              "translations",
              `return ${newCol.content};`
            )(language, translations);
          } catch (e) {
            console.error("Error evaluating content:", col.content, e);
          }
        }

        return newCol;
      })}
      const processedViews = data?.user_views?.map((view) => ({
        ...view,
        columns: processColumns(view.columns || []),
      }));
      
      
      setTableViews(processedViews);
      const currentViewObj = processedViews.find(
        (item) => item.current === "1"
      );

      setCurrentView({
        ...currentViewObj,
        columns: currentViewObj?.columns || [],
      });
    }
    // getFiltersData();
  }, [eventId, data]);
  const fetchData = async (value = false) => {
    try {
      if(!value){
      setLoading(true);

      }
      const res = await fetch(ApiUrl + `/api/user/prospective-index/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(
          clientsFilterData && clientsFilterData?.length > 0
            ? {
                ...clientsFilterPostData,
                private_event_id: eventId,
                all_prospects: false,
              }
            : {
                private_event_id: eventId,
                all_prospects: false,
              }
        ),
      });
      const data = await res.json();
      if (data.status === "success") {
        // const newData = data.private_events.data;
        const callOptions =
          data.prospectives && data.prospectives.length > 0
            ? Array.from(
                new Set(
                  data.prospectives
                    .filter((item) => item?.call_status != null) // Filter out null or undefined call_status
                    .map((item) => item.call_status.toString()) // Map to call_status strings
                )
              ).map((call_status) => ({
                label: call_status,
                value: call_status,
              }))
            : [];

        setClients(data.prospectives);
        setLinks({
          csv_template_en: data.csv_template_en,
          csv_template_fr: data.csv_template_fr,
        });
        setCallStatusOptions(callOptions);
        seListId({ list_id: data.liste_id, list_name: data.list_name });
        setDealershipDetail(data?.dealershipDetails);
        setDeleteStates(data.prospectives.map(() => false));

        // autoScrollMid();
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setLoading(false);
    }
  };

  const getExternalUsers = async () => {
    // setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/external-user/" + eventId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        const typeOptions = data?.prospective_type?.length
          ? data?.prospective_type?.map((list) => ({
              label: list,
              value: list,
            }))
          : [];

        setProspectiveType(typeOptions);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setIsLoading(false);
    }
  };
  const getListIds = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/list-ids/" + eventId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        const configs =
          data?.config_ids?.lists &&
          data?.config_ids?.lists.length > 0 &&
          data?.config_ids?.lists.map((list) => {
            return {
              label: list?.calendar_config_name,
              value: list?.calendar_config_id,
            };
          });
        const lists =
          data?.list_ids?.lists &&
          data?.list_ids?.lists.length > 0 &&
          data?.list_ids?.lists.map((list) => {
            return { label: list?.list_name, value: list?.list_id };
          });

        setListIds(lists);
        setConfigIds(configs);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id, index) => {
    setLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/prospectives/" + id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        // toast.success("Dealership deleted successful");
        const newData = clients.filter((client) => client.id !== id);
        setClients(newData);
        // Update delete state for the current item
        const newDeleteStates = [...deleteStates];
        newDeleteStates[index] = false;
        setDeleteStates(newDeleteStates);
      } else {
        toast.error(data.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  const handleCheckboxChange = (clientId) => {
    setSelectedClients(
      (prevSelected) =>
        prevSelected.includes(clientId)
          ? prevSelected.filter((id) => id !== clientId) // Deselect if selected
          : [...prevSelected, clientId] // Add if not selected
    );
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      // Deselect all
      setSelectedClients([]);
    } else {
      // Select all appointments' IDs
      const allClientIds = clients.map((client) => client.id);
      setSelectedClients(allClientIds);
    }
    setSelectAll(!selectAll); // Toggle the state of selectAll
  };
  const exportToExcel = () => {
    // Filter the selected appointments based on their IDs
    const selectedData = clients
      .filter((client) => selectedClients.includes(client.id)) // Only include selected appointments
      .map((client) => ({
        Event_ID: client?.private_event?.nom_vp || "",
        Prospect_Type: client?.prospect_type || "",
        Prospect_Source: client?.prospect_source || "",
        First_Name: client?.first_name || "",
        Last_Name: client?.last_name || "",
        Phone: client?.phone || "",
        Office_Number: client?.office_phone || "",
        Representative: client?.og_rep || "",
        Call_Status: client?.call_status || "",
        Make: client?.make || "",
        Model: client?.model || "",
        Year: client?.year || "",
        Confirmation_Status: client?.appointments[0]?.confirmation_status || "",
        Confirmation_Notes: client?.appointments[0]?.confirmation_notes || "",
        Visit_Status: client?.appointments[0]?.visit_status || "",
        Visit_Notes: client?.appointments[0]?.visit_notes || "",
        No_Show_Status: client?.appointments[0]?.no_show_status || "",
        No_Show_Notes: client?.appointments[0]?.no_show_notes || "",

        appointment_time: client?.appointments[0]?.appointment_time || "",
        appointment_date: client?.appointments[0]?.appointment_date || "",
        appointment_comment: client?.appointments[0]?.appointment_comment || "",
        appointment_rep_user_name:
          client?.appointments[0]?.appointment_rep_user_name || "",
        Province: client?.province || "",
        Purchase_Date: client?.purchase_date || "",
        VIN: client?.vin || "",
        Visit_Status_User: client?.visit_status_user || "",
        Email: client?.email || "",
        Greetings: client?.greetings || "",
        Client_ID: client?.id || "",
        KM: client?.km || "",
        Language: client?.language || "",
        List_ID: client?.list_id || "",
        Mobile_Phone: client?.mobile_phone || "",
        Postal_Code: client?.postal_code || "",
        Address: client?.address || "",
        Appointment: client?.appointment || "",
        City: client?.city || "",
      }));

    // Generate the Excel sheet
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Clients");

    // Save the file
    XLSX.writeFile(
      workbook,
      `Clients Report ${format(new Date(), "dd/MM/yyyy")}.xlsx`
    );
  };

  const exportDataZip = async () => {
      if (!currentView || !currentView.columns) {
      console.error("Current view is not set or missing columns.");
      return;
    }

    // Extract column keys from `currentView.columns`
    
      console.log("klasdjkldjsf",selectedClients)
    const payload = {
      ids: selectedClients,
    };
  setDownloadingZip(true)
    try {
      const res = await fetch(ApiUrl + "/api/user/download-bulk-dealership-pdfs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (!res.ok) {
        throw new Error("Failed to download file");
      }
  
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
  
      // Create a link to trigger download
      const link = document.createElement("a");
      link.href = url;
      link.download = "dealerships.zip"; // or .zip depending on server response
      document.body.appendChild(link);
      link.click();
  
      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
    }
    finally{
      setDownloadingZip(false)
    }
  };
  const exportData = (fileType) => {
    if (!currentView || !currentView.columns) {
      console.error("Current view is not set or missing columns.");
      return;
    }

    // Helper function to translate column headers
    const getTranslatedColumnHeader = (columnId) => {
      const columnTranslationMap = {
        "id": "ID",
        "prospect_type": translations.clients.table.prospectiveType[language],
        "prospect_source": translations.createProspective.prospectiveSource[language],
        "first_name": translations.commonFields.firstName[language],
        "last_name": translations.commonFields.lastName[language],
        "phone": translations.quickCreationModal.phoneNumber[language],
        "office_phone": translations.createProspective.officeNumber[language],
        "email": translations.commonFields.email[language],
        "og_rep": translations.commonWords.usersTypes.representative[language],
        "call_status": translations.clients.table.callStatus[language],
        "make": translations.createProspective.make[language],
        "model": translations.createProspective.model[language],
        "year": translations.usersPage.createUser.year[language],
        "general_comment": translations.createProspective.generalComment[language],
        "km": "KM",
        "address": translations.commonFields.address[language],
        "city": translations.commonFields.city[language],
        "province": translations.commonFields.province[language],
        "postal_code": translations.forms.formFields.conquestSection.postalCode[language],
        "appointment": translations.appointments.appointment[language],
        "mobile_phone": translations.commonFields.mobileNumber[language],
        "language": translations.commonFields.language[language],
        "vin": translations.createProspective.VIN[language],
        "purchase_date": translations.createProspective.purchaseDate[language],
        "last_service_date": translations.createProspective.lastServiceDate[language],
        "greetings": translations.createProspective.greetings[language],
        "confirmation_status": translations.createProspective.confirmationStatus[language],
        "confirmation_notes": translations.createProspective.confirmationNotes[language],
        "visit_status": translations.createProspective.visitStatus[language],
        "visit_notes": translations.createProspective.visitNotes[language],
        "no_show_status": translations.clients.table.noShowStatus[language],
        "no_show_notes": translations.createProspective.noShowNotes[language],
        "appointment_rep_user_name": translations.createProspective.appointmentRepresentative[language],
        "appointment_time": translations.clients.table.appointmentTime[language],
        "appointment_date": translations.clients.table.appointmentDate[language],
        "appointment_comment": translations.createProspective.appointmentComment[language],
        "import_note": translations.createProspective.import_note[language],
        "group_code": translations.createProspective.group_code[language],
        "create_by": translations.createProspective.bookedBy[language],
        "actions": translations.EventsPortal.eventsTableHeader.actions[language],
      };
      
      return columnTranslationMap[columnId] || columnId;
    };

    // Extract column keys from `currentView.columns`\
    // console.log("currentView.columns",currentView.columns)
    const selectedColumns = currentView.columns
      .slice(0, -1)
      .filter((item) => item.renderInView !== false)
      .map((col) => ({
        key: col.id, // Assuming column `id` matches the data field name
        header: getTranslatedColumnHeader(col.id), // Use translated header
      }));

    const selectedData =
      clients && clients.length > 0
        ? clients.filter((client) => selectedClients.includes(client.id)).map((client) => {
            let rowData = {};

            // Add only the selected columns with proper transformations
            selectedColumns.forEach(({ key, header }) => {
              let value = "";

              // Apply transformation logic based on columnKey
              if (key === "prospect_source") {
                if (client?.prospect_source) {
                  const matchedOption = prospectiveSourceOptions.find(
                    (option) =>
                      option.value.en?.toLowerCase() ===
                        client?.prospect_source?.toLowerCase() ||
                      option.value.fr?.toLowerCase() ===
                        client?.prospect_source?.toLowerCase()
                  );
                  value = matchedOption
                    ? matchedOption.label[language]
                    : client?.prospect_source;
                }
              } else if (key === "confirmation_status") {
                value = getTranslatedConfirmationStatus(
                  client?.appointments?.[0]
                )?.confirmation_status;
              } else if (key === "confirmation_notes") {
                value = client?.appointments?.[0]?.confirmation_notes || "";
              } else if (key === "visit_status") {
                value = getTranslatedVisitStatus(
                  client?.appointments?.[0]?.visit_status
                );
              } else if (key === "visit_notes") {
                value = client?.appointments?.[0]?.visit_notes || "";
              } else if (key === "no_show_status") {
                value = getTranslatedNoShowStatus(
                  client?.appointments?.[0]?.no_show_status
                );
              } else if (key === "no_show_notes") {
                value = client?.appointments?.[0]?.no_show_notes || "";
              } else if (key === "appointment") {
                value = client[key] === 0 || client[key] === "0" ? "No" : "Yes";
              } else if (key === "create_by") {
                value = client[key]?.name || "";
              } else {
                value = client?.appointments?.[0]?.[key] || client[key] || "";
              }

              rowData[header] = value;
            });

            return rowData;
          })
        : [];

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");

    // Determine file type (CSV or XLSX)
    if (fileType === "csv") {
      const csvData = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvData], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${language === 'fr' ? 'Exportation_Clients' : 'Export_Clients'}_${format(
        new Date(),
        "dd/MM/yyyy"
      )}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      XLSX.writeFile(
        workbook,
        `${language === 'fr' ? 'Exportation_Clients' : 'Export_Clients'}_${format(new Date(), "dd/MM/yyyy")}.xlsx`
      );
    }
  };

  const getFilteredEvents = async (filterPost, checkedFieldsData) => {
    // setIsLoading(true);
    // setAllowScrollFetch(false);

    try {
      const res = await fetch(ApiUrl + "/api/user/prospective-index", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          private_event_id: eventId,
          ...filterPost,
          all_prospects: false,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        localStorage.setItem(
          "clientsFilterPostData",
          JSON.stringify(filterPost)
        );
        localStorage.setItem(
          "clientsFilterData",
          JSON.stringify(checkedFieldsData)
        );
        setClients(data.prospectives);
        setDeleteStates(data.prospectives.map(() => false));
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      // setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      // setAllowScrollFetch(true);
      setLoading(false);
    }
  };

  const getTranslatedConfirmationStatus = (status) => {
    const option = confirmationStatusOptions.find(
      (opt) => opt.value === status
    );
    return option ? option.label : status;
  };
  const getTranslatedVisitStatus = (status) => {
    const option = visitStatusOptions.find((opt) => opt.value === status);
    return option ? option.label : status;
  };

  const getTranslatedNoShowStatus = (status) => {
    const option = noShowOptions.find((opt) => opt.value === status);
    return option ? option.label : status;
  };

  const moveColumn = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = currentView.columns.findIndex(
      (col) => col.id === active.id
    );
    const newIndex = currentView.columns.findIndex((col) => col.id === over.id);

    const reorderedColumns = arrayMove(currentView.columns, oldIndex, newIndex);
    const updatedData = { ...currentView, columns: reorderedColumns };
    setCurrentView((prevView) => ({ ...prevView, columns: reorderedColumns }));
    if (updatedData.type !== "default client") {
      updateView(updatedData);
    }
  };

  const handleResize = (columnId, newWidth) => {
    columnWidthsRef.current[columnId] = newWidth;
    // const newColumns = columns.map((col) =>
    //   col.id === columnId ? { ...col, width: newWidth } : col
    // );
    // setColumns(newColumns);
    // Immediate visual update
    requestAnimationFrame(() => {
      const columnElement = document.getElementById(columnId);
      if (columnElement) columnElement.style.width = `${newWidth}px`;
    });
    // Mark that a state update is needed
    if (!pendingStateUpdate.current) {
      pendingStateUpdate.current = true;
      debouncedUpdate(setCurrentView);
    }
  };

  // Debounce for smoother updates instead of throttle
  const debouncedUpdate = debounce((setCurrentView) => {
    const updatedData = {
      ...currentView,
      columns: currentView.columns.map((col) =>
        col.id in columnWidthsRef.current
          ? { ...col, width: columnWidthsRef.current[col.id] }
          : col
      ),
    };
    setCurrentView((prevColumns) => ({
      ...prevColumns,
      columns: prevColumns.columns.map((col) =>
        col.id in columnWidthsRef.current
          ? { ...col, width: columnWidthsRef.current[col.id] }
          : col
      ),
    }));
    if (updatedData.type !== "default client") {
      updateView(updatedData);
    }
    pendingStateUpdate.current = false; // Reset flag after update
  }, 16); // Adjust delay as needed

  const updateView = async (updatedData) => {
    try {
      const res = await fetch(ApiUrl + "/api/user/views", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedData),
      });
      const data = await res.json();
      if (data.status === "success") {
        // toast.success(data?.message);
        const viewData2 = {
          ...data.userView,
          columns: JSON.parse(data.userView.columns),
        };
        setTableViews((prev) =>
          prev.map((item) => {
            if (item.id === updatedData.id) {
              return viewData2;
            }
            return item;
          })
        );
      } else {
        toast.error(translations.alertMessages.wentWrong[language]);
      }
    } catch (error) {
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => debouncedUpdate.cancel();
  }, [data]);

  function updateTooltipPositioning() {
    const tooltips = document.querySelectorAll(".custom-tooltip");
    const windowWidth = window.innerWidth;

    tooltips.forEach((tooltip) => {
      const rect = tooltip.getBoundingClientRect();
      const tooltipText = tooltip.querySelector(".custom-tooltiptext");

      // Remove existing positioning classes
      tooltip.classList.remove("left-edge", "right-edge");

      // Check left edge (less than 100px from left)
      if (rect.left < 100) {
        tooltip.classList.add("left-edge");
      }
      // Check right edge (less than 100px from right)
      else if (windowWidth - rect.right < 100) {
        tooltip.classList.add("right-edge");
      }

      // Force recalculation of tooltip width to ensure content fits
      // This is especially important for left-aligned tooltips
      if (tooltip.classList.contains("left-edge")) {
        const maxWidth = Math.min(300, windowWidth - 20); // Ensure it's not wider than viewport
        tooltipText.style.maxWidth = `${maxWidth}px`;
      }
    });
  }

  useEffect(() => {
    // Initial call
    updateTooltipPositioning();

    // Add resize listener
    window.addEventListener("resize", updateTooltipPositioning);

    const targetNode = document.querySelector(".headersec");
    const observer = new MutationObserver(updateTooltipPositioning);

    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      });
    } else {
      console.warn(
        "Element '.headersec' not found, skipping MutationObserver setup."
      );
    }

    return () => {
      window.removeEventListener("resize", updateTooltipPositioning);
      observer.disconnect();
    };
  }, [clientsFilterData]);

  return (
    <div>
      {!loading ? (
        <div className="container maincont">
          <div id="app" className="appcountainer2 client-table-container">
            <BulkUpload
              isDarkMode={isDarkMode}
              eventId={eventId}
              listIds={listIds}
              configIds={configIds}
              getListIds={getListIds}
              fetchData={fetchData}
              links={links}
            />
            <ClientsFilterbar
              isDarkMode={isDarkMode}
              allfields={allfields}
              checkedFields={checkedFields}
              setCheckedFields={setCheckedFields}
              textOptions={textOptions}
              textOptions2={textOptions2}
              appointmentOption={appointmentOption}
              prospectiveSourceOptions={prospectiveSourceOptions2}
              callStatusOptions={callStatusOptions}
              filtersData={filtersData}
              setFiltersData={setFiltersData}
              // filterOption={filterOption}
              // setFilterOption={setFilterOption}
              // dealerOptions={dealerOptions}
              // repOptions2={repOptions2}
              // managers={managers}
              // packageOptions={packageOptions}
              // animatorOptions={animatorOptions}
              getFilteredEvents={getFilteredEvents}
              prospectiveType={prospectiveType}
              // weekOptions={weekOptions}
            />
            
            <AddViewModal
              isDarkMode={isDarkMode}
              // getColumns={
              //   (data?.user_views &&
              //     data.user_views?.find(
              //       (item) => item.type === "default client"
              //     )) ||
              //   {}
              // }
              getColumns={AllClientColoumnData}
              setTableViews={setTableViews}
              setIsLoading={setIsLoading}
              viewData={viewData}
              setViewData={setViewData}
              setCurrentView={setCurrentView}
              tableType={"client"}
            />
            <EventViewHeader
              eventId={eventId}
              isDarkMode={isDarkMode}
              setDisplayComponent={setDisplayComponent}
              activePage="clients"
              title={translations.clients.title[language]}
              dealershipDetails={dealershipDetail}
            >
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary"
                  onClick={() => {
                    setDisplayComponent("create-prospective");
                    window.history.pushState(
                      {
                        id: "gallery",
                        randomData: window.Math.random(),
                      },
                      "title",
                      `/event-portal?page=create-prospective&eventId=${eventId}`
                    );
                  }}
                >
                  <i className={`bi bi-clipboard-plus`}></i>{" "}
                  {translations.commonFields.addBtn[language]}
                </button>
              </div>
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                {userType &&
                  internalUsers.includes(userType) &&
                  userType !== "Animator" && (
                    <button
                      type="button"
                      className="btn admin-btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#bulkUploadModal"
                      id="add-dlr-trigger"
                    >
                      <i className="bi bi-upload"></i>{" "}
                      {translations.commonFields.bulkUpload[language]}
                    </button>
                  )}
              </div>

              {/* {currentView &&
                (currentView?.csv === "1" ||
                  currentView?.csv === true ||
                  currentView?.xlsx === "1" ||
                  currentView?.xlsx === true) && ( */}
                  {userType && selectedClients && selectedClients.length > 0 &&
                  userData.roles[0].permissions.some(
                                            (item) =>
                                              item.name ===
                                              "Event Data Export"
                                          ) &&
                  // (userType === "Super Admin" || userType === "Admin") 
                   (
                    <>
                     {/* <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <div className="btn-group" role="group">
                        <button
                          type="button"
                          className="btn admin-btn btn-primary edit-button d-flex align-items-center justify-content-center gap-1 mx-auto"
                          style={{
                            width: "100%",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                          disabled={downloadingZip}
                          onClick={() => {
                            exportDataZip("zip");
                          }}
                        >
                          <i class="bi bi-file-zip"></i>{" "}
                        </button>
                    </div>
                     </div> */}


                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <div className="btn-group" role="group">
                      {/* {(currentView?.xlsx === true ||
                        currentView?.xlsx === "1") && ( */}
                        <button
                          type="button"
                          className="btn admin-btn btn-primary edit-button d-flex align-items-center justify-content-center gap-1 mx-auto"
                          style={{
                            width: "100%",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            exportData("xlsx");
                          }}
                        >
                          <i className={"bi bi-filetype-xlsx"}></i>{" "}
                        </button>

                      {/* )} */}
                      {/* {(currentView?.csv === true ||
                        currentView?.csv === "1") && ( */}
                        <button
                          type="button"
                          className="btn btn-danger edit-button d-flex align-items-center justify-content-center gap-1 mx-auto"
                          style={{
                            width: "100%",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                          onClick={() => {
                            exportData("csv");
                          }}
                        >
                          <i className={"bi bi-filetype-csv"}></i>{" "}
                        </button>
                      {/* )} */}
                    </div>
                  </div>
                  </>
                )}

              <div className="btn-group"  style={{width:'250px'}}>
                <button
                  type="button"
                  className="btn btn-light dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  // style={{ width: "125px" }}
                  style={{
                          width: "125px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                >
                  {/* {translations.EventsPortal.views.default[language]} */}
                  {/* {currentView?.name} */}
                  {
                         language == "fr" && (currentView?.name === "Default View")  ?
                                     "Vue par défaut" 
                                     :
                                     currentView?.name 

                        }

                </button>
                <ul
                  className="dropdown-menu"
                  style={{
                    minWidth: "250px",
                    background: isDarkMode ? "#2b3035" : "#FFFFFF",
                  }}
                >
                  <li style={{ maxHeight: "200px", overflow: "auto" }}>
                    {tableViews &&
                      tableViews.map((view, index) => (
                        <li
                          className="w-100"
                          key={index}
                          style={{
                            ":hover": {
                              backgroundColor: isDarkMode
                                ? "#343A3F"
                                : "#34DBB4",
                            },
                          }}
                        >
                          <div
                            className={`dropdown-item ${
                              isDarkMode ? "views-hover-dark" : "views-hover"
                            }  px-2 d-flex align-items-center justify-content-between w-100`}
                            href="#"
                            style={{
                              ":hover": {
                                background: isDarkMode
                                  ? "#343A3F"
                                  : "#34DBB4",
                              },
                            }}
                          >
                            <p
                              style={{ cursor: "pointer",width:'95%' }}
                              onClick={() => {
                                const updatedData = tableViews.map((item) =>
                                  item.id === view.id
                                    ? { ...item, current: true }
                                    : { ...item, current: false }
                                );
                                setTableViews(updatedData);
                                setCurrentView({ ...view, current: true });
                                updateView({ ...view, current: true });
                              }}
                            >
                              {
                                  language == "fr" && (view.name === "Default View")  ?
                                     "Vue par défaut" 
                                     :
                                     language == "fr" && (view.name === "Contract and Billing") ?
                                           "Contrat et facturation"
                                        :
                                     view.name

                                }
                              {/* {view.name} */}
                            </p>
                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ fontSize: "18px" }}
                            >
                              <i
                                className="bi bi-star-fill"
                                style={{
                                  color:
                                    currentView?.id === view?.id
                                      ? "gold"
                                      : "#adb5bd",
                                }}
                              ></i>{" "}
                              <i
                                className="bi bi-pencil-fill"
                                style={{
                                  color:
                                    view.type === "default client"
                                      ? "#adb5bd"
                                      : "#445775",
                                  cursor:
                                    view.type === "default client"
                                      ? "default"
                                      : "pointer",
                                }}
                                onClick={() => {
                                  if (view.type !== "default client") {
                                    setViewData({ ...view, mode: "edit" });
                                    button.click();
                                  }
                                }}
                              ></i>{" "}
                              <i
                                className="bi bi-trash-fill"
                                style={{
                                  color:
                                    currentView?.id === view?.id ||
                                    view.type === "default client"
                                      ? "#adb5bd"
                                      : "#dc3545",
                                  cursor:
                                    currentView?.id === view?.id ||
                                    view.type === "default client"
                                      ? "default"
                                      : "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    currentView?.id !== view?.id &&
                                    view.type !== "default client"
                                  ) {
                                    setViewData({
                                      ...view,
                                      mode: "delete",
                                    });
                                    button.click();
                                  }
                                }}
                              ></i>{" "}
                            </div>
                          </div>
                        </li>
                      ))}
                  </li>

                  <li className="px-2 mt-2 w-100">
                    <button
                      type="button"
                      className="btn btn-light w-100"
                      data-bs-toggle="modal"
                      data-bs-target="#addViewModal"
                      fdprocessedid="2rud2c"
                      id="openViewModal"
                    >
                      <i className="bi bi-plus"></i>{" "}
                      {translations.EventsPortal.views.addNewView[language]}
                    </button>
                  </li>
                </ul>
              </div>
               <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  id=""
                  type="button"
                  className="btn admin-btn btn-primary"
                  data-bs-target="#clientFiltersidebar"
                  data-bs-toggle="offcanvas"
                  aria-bs-controls="offcanvasmain"
                >
                  <i className="bi bi-search"></i>{" "}
                </button>
              </div>
            </EventViewHeader>
            <div className="headersec row">
              <div className="mb-3 col-12">
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  {clientsFilterData &&
                    clientsFilterData?.length > 0 &&
                    clientsFilterData?.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex py-1 px-2 gap-2 align-items-center justify-content-between custom-tooltip"
                        style={{
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                          borderRadius: "0.275rem",
                          minWidth: "150px",
                          maxWidth: "250px",
                        }}
                      >
                        <span className="custom-tooltiptext">{`${
                          item?.content
                        } : ${
                          Array.isArray(item?.value)
                            ? item.value
                                .map(
                                  (id) =>
                                    (item.name === "appointment"
                                      ? appointmentOption
                                      : item.name === "prospect_source"
                                      ? prospectiveSourceOptions
                                      : item.name === "prospective_type"
                                      ? prospectiveType
                                      : item.name === "call_status"
                                      ? callStatusOptions
                                      : textOptions
                                    )?.find(
                                      (option) =>
                                        option.value?.toString() ===
                                        id?.toString()
                                    )?.label || id
                                )
                                ?.join(", ")
                            : item?.value
                        }`}</span>
                        <div
                          className="d-flex align-items-center gap-2 justify-content-start"
                          style={{ width: "90%" }}
                        >
                          {/* Container for Content */}
                          <div className="text-truncate">
                            <span>
                              {item?.content}{" "}
                              {translations.commonWords.is[language]}{" "}
                            </span>
                          </div>
                          {/* Container for Value */}
                          <div
                            className="text-truncate"
                            style={{
                              maxWidth: "60%",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {Array.isArray(item?.value)
                              ? item.value
                                  .map(
                                    (id) =>
                                      (item.name === "appointment"
                                        ? appointmentOption
                                        : item.name === "prospect_source"
                                        ? prospectiveSourceOptions
                                        : item.name === "prospective_type"
                                        ? prospectiveType
                                        : item.name === "call_status"
                                        ? callStatusOptions
                                        : textOptions
                                      )?.find(
                                        (option) =>
                                          option.value?.toString() ===
                                          id?.toString()
                                      )?.label || id
                                  )
                                  ?.join(", ")
                              : item?.value}
                          </div>
                        </div>

                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            let updatedCheckedFields = checkedFields.filter(
                              (field) => field.name !== item.name
                            );
                            setCheckedFields(updatedCheckedFields);

                            const keysToRemove = [item.name];
                            const updatedFiltersData = Object.fromEntries(
                              Object.entries(filtersData).filter(
                                ([key]) => !keysToRemove.includes(key)
                              )
                            );

                            setFiltersData(updatedFiltersData);
                            getFilteredEvents(
                              updatedFiltersData,
                              updatedCheckedFields
                            );
                          }}
                        >
                          <i
                            className="bi bi-x-circle-fill"
                            style={{
                              color: isDarkMode ? "#495057" : "#868686",
                            }}
                          ></i>
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={moveColumn}
            >
              <SortableContext
                items={
                  currentView &&
                  currentView?.columns?.slice(1, -1)?.map((col) => col.id)
                }
                strategy={horizontalListSortingStrategy}
              >
                <div
                  // className="pt-4"
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "column",
                  //   justifyContent: "space-between",
                  // }}
                  // ref={containerRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowX: "auto",
                    justifyContent: "space-between",
                    // height: "calc(100vh - 260px)",
                    height:'auto',
                    maxHeight: `calc(100vh - ${clientsFilterData?.length > 0 ? '329px' : '295px' } )`,
                  }}
                >
                  <table
                    // className="table table-hover text-center align-middle"
                    className="align-content-center align-middle"
                    style={{
                      minWidth: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                    }}
                  >
                    <thead
                      style={{ position: "sticky", top: "0", zIndex: "1" }}
                    >
                      <tr
                        style={{
                          background: isDarkMode ? "#1b1f22" : "#ffffff",
                          borderBottom:'1px solid'
                        }}
                      >
                        {userData &&
                          (userData.roles[0].name === "Super Admin" ||
                            userData.roles[0].name === "Admin") && (
                            <th
                              scope="col"
                              className={`${isDarkMode ? "darkthead" : ""}`}
                              style={{width:'20px'}}
                            >
                              {
                                <input
                                  type="checkbox"
                                  className=""
                                  checked={selectAll}
                                  onChange={handleSelectAllChange}
                                />
                              }
                            </th>
                          )}
                        {
                          <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""} ${
                              currentView?.columns[0]?.className || ""
                            }`}
                            style={{
                              ...currentView?.columns[0]?.style,
                              width: `${currentView?.columns[0]?.width}px`,
                              paddingInline: "56px !important",
                              marginInline: "4px !important",
                              background: isDarkMode ? "#1b1f22" : "#ffffff",
                              // background: isDarkMode ? "#343a3f" : "#ffffff",
                            }}
                            colSpan={currentView?.columns[0]?.colSpan}
                          >
                            {/* <div
                              className="column-content"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                className={`p-2 ${
                                  isDarkMode ? "darkthead" : ""
                                }`}
                              > */}
                            {currentView?.columns[0]?.content}
                            {/* </span>
                            </div> */}
                          </th>
                        }
                        {currentView?.columns
                          .slice(1, -1)
                          .filter((header) => header.renderInView !== false)
                          .map((header) =>
                            header.showIf !== false ? (
                              <DraggableHeaderCell
                                key={header.id}
                                column={header}
                                isDarkMode={isDarkMode}
                                onResize={handleResize}
                              />
                            ) : null
                          )}

                        {currentView?.columns
                          .filter((header) => header.renderInView !== false)
                          .some((column) => column.id === "actions") && (
                          <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""} ${
                              currentView?.columns[
                                currentView?.columns.length - 1
                              ]?.className || ""
                            }`}
                            style={{
                              ...currentView?.columns[
                                currentView.columns.length - 1
                              ]?.style,
                              width: `${
                                currentView?.columns[
                                  currentView?.columns.length - 1
                                ]?.width
                              }px`,
                              paddingInline: "56px !important",
                              marginInline: "4px !important",
                              background: isDarkMode ? "#1b1f22" : "#ffffff",
                              // background: isDarkMode ? "#343a3f" : "#ffffff",
                              position:'sticky',
                              right:'0px'
                            }}
                            colSpan={
                              currentView?.columns[
                                currentView?.columns.length - 1
                              ]?.colSpan
                            }
                          >
                            {/* <div
                              className="column-content"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span
                                className={`p-2 ${
                                  isDarkMode ? "darkthead" : ""
                                }`}
                              > */}
                            {
                              currentView?.columns[
                                currentView?.columns.length - 1
                              ]?.content
                            }
                            {/* </span>
                            </div> */}
                          </th>
                        )}

                        {/* <th scope="col"></th> */}
                      </tr>
                    </thead>
                    {clients && !loading && (
                      <tbody id="">
                        {clients && clients.length > 0 ? (
                          clients.map((client, index) => {
                            return (
                              <>
                                <tr className="result-box highlight-text-onhover" key={client?.id}
                                style={{ borderBottom:'1px solid',
                                }}
                              //   onClick={() =>
                              //   setClickedRow(clickedRow === client?.id ? null : client?.id)
                              // }
                                >
                                  {userData &&
                                    (userData.roles[0].name === "Super Admin" ||
                                      userData.roles[0].name === "Admin") && (
                                      <td
                                        className="fw-bold"
                                        style={
                                          {
                                            // backgroundColor: "#ced4da66",
                                            // borderTop: "1px solid #dee2e6",
                                            // borderBottom: "1px solid #dee2e6",
                                          }
                                        }
                                      >
                                        {
                                          <input
                                            type="checkbox"
                                            className=""
                                            checked={selectedClients.includes(
                                              client.id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(client.id)
                                            }
                                          />
                                        }
                                      </td>
                                    )}
                                  <th
                                    className="custID highlight-text-color"
                                    scope="row"
                                    style={{ paddingInline: "25px" }}
                                    
                                  >
                                    {client?.id}
                                  </th>
                                  {currentView &&
                                    currentView?.columns &&
                                    currentView?.columns
                                      .slice(1, -1)
                                      .filter(
                                        (header) =>
                                          header.renderInView !== false
                                      )
                                      .map((col) => {
                                        if (col.showIf === false) return null; // Skip columns with showIf: false

                                        const columnKey = col.id;

                                        return (
                                          <td
                                            className="highlight-text-color "
                                            scope="row"
                                            id={columnKey}
                                            key={col.id}
                                            style={col.style}
                                          >
                                            {columnKey === "prospect_source"
                                              ? client?.prospect_source
                                                ? (() => {
                                                    const matchedOption =
                                                      prospectiveSourceOptions.find(
                                                        (option) =>
                                                          option.value.en?.toLowerCase() ===
                                                            client?.prospect_source?.toLowerCase() ||
                                                          option.value.fr?.toLowerCase() ===
                                                            client?.prospect_source?.toLowerCase()
                                                      );

                                                    // Return the label in the current language if a match is found
                                                    return matchedOption
                                                      ? matchedOption.label[
                                                          language
                                                        ]
                                                      : client?.prospect_source;
                                                  })()
                                                : ""
                                              : columnKey ===
                                                "confirmation_status"
                                              ? getTranslatedConfirmationStatus(
                                                  client?.appointments[0]
                                                )?.confirmation_status
                                              : columnKey ===
                                                "confirmation_notes"
                                              ? client?.appointments[0]
                                                  ?.confirmation_notes
                                              : columnKey === "visit_status"
                                              ? getTranslatedVisitStatus(
                                                  client?.appointments[0]
                                                    ?.visit_status
                                                )
                                              : columnKey === "visit_notes"
                                              ? client?.appointments[0]
                                                  ?.visit_notes
                                              : columnKey === "no_show_status"
                                              ? getTranslatedNoShowStatus(
                                                  client?.appointments[0]
                                                    ?.no_show_status
                                                )
                                              : columnKey === "no_show_notes"
                                              ? client?.appointments[0]
                                                  ?.no_show_notes
                                              : columnKey === "appointment"
                                              ? client[columnKey] === 0 ||
                                                client[columnKey] === "0"
                                                ? "No"
                                                : "Yes"
                                              : columnKey === "create_by" ? client[columnKey]?.name  : client?.appointments[0]?.[
                                                  columnKey
                                                ] ||
                                                client[columnKey] ||
                                                ""}
                                          </td>
                                        );
                                      })}

                                  {currentView?.columns
                                    .filter(
                                      (header) => header.renderInView !== false
                                    )
                                    .some(
                                      (column) => column.id === "actions"
                                    ) && (
                                    <>
                                      <td
                                        style={{
                                          background: 
                                          isDarkMode
                                            ? "#212529"
                                            : "#ffffff" ,
                                          position: "-webkit-sticky",
                                          position: "sticky",
                                          right: 0,
                                        }}
                                        className="highlight-text-action"
                                         
                                      >
                                        <div className="d-flex justify-content-end align-items-center gap-2" >
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-light edit-button d-flex align-items-center justify-content-center gap-1 mx-auto"
                                              //   data-customer-id="405"
                                              //   data-bs-toggle="modal"
                                              //   data-bs-target="#AddDealerModal"
                                              onClick={() => {
                                                setDisplayComponent(
                                                  "edit-prospective"
                                                );
                                                //   setEditEventID(event.id);
                                                window.history.pushState(
                                                  {
                                                    id: "gallery",
                                                    randomData:
                                                      window.Math.random(),
                                                  },
                                                  "title",
                                                  "/event-portal?page=edit-prospective&event_id=" +
                                                    eventId +
                                                    `&client_id=${client?.id}`
                                                );
                                              }}
                                            >
                                              <i className="bi bi-eye"></i>{" "}
                                              {
                                                translations.commonWords.view[
                                                  language
                                                ]
                                              }
                                            </button>
                                          </div>
                                          
                                          {userData &&
                                            userData.roles[0].permissions.some(
                                              (item) =>
                                                item.name ===
                                                "Prospective Destroy"
                                            ) && (
                                              <div
                                                className="btn-group"
                                                role="group"
                                              >
                                                {deleteStates[index] ? (
                                                  <>
                                                    <button
                                                      type="button"
                                                      className="btn btn-success delete-button"
                                                      data-customer-id="405"
                                                      onClick={() =>
                                                        handleDelete(
                                                          client?.id,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {
                                                        translations
                                                          .commonFields.confirm[
                                                          language
                                                        ]
                                                      }
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn btn-secondary cancel-button"
                                                      onClick={() =>
                                                        setDeleteStates(
                                                          (prevStates) => {
                                                            const newStates = [
                                                              ...prevStates,
                                                            ];
                                                            newStates[
                                                              index
                                                            ] = false;
                                                            return newStates;
                                                          }
                                                        )
                                                      }
                                                    >
                                                      {
                                                        translations
                                                          .commonFields.cancel[
                                                          language
                                                        ]
                                                      }
                                                    </button>
                                                  </>
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="btn btn-danger before-delete-button d-flex align-items-center justify-content-center gap-1 mx-auto"
                                                    dataset-button-state="delete"
                                                    onClick={() =>
                                                      setDeleteStates(
                                                        (prevStates) => {
                                                          const newStates = [
                                                            ...prevStates,
                                                          ];
                                                          newStates[
                                                            index
                                                          ] = true;
                                                          return newStates;
                                                        }
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-trash"></i>{" "}
                                                    {
                                                      translations.commonFields
                                                        .delete[language]
                                                    }
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                        </div>
                                      </td>
                                    </>
                                  )}
                                </tr>
                              </>
                            );
                          })
                        ) : (
                          <tr
                            className="align-middle"
                            style={{
                              position: "relative",
                              // height: "30px",
                              // zIndex: 10 + eventList.length - index,
                            }}
                          >
                            <td
                              style={{
                                background: `${
                                  isDarkMode ? "transparent" : "white"
                                }`,
                                borderStyle: "none",
                              }}
                              colSpan={14}
                              className="text-center py-5"
                            >
                              <h4>
                                {
                                  translations.EventsPortal.noDataMessage[
                                    language
                                  ]
                                }
                              </h4>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                  {/* <div ref={bottomMarkerRef} style={{ height: "1px" }} /> */}
                </div>
              </SortableContext>
            </DndContext>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Clients;
